export default __webpack_public_path__ + "static/sitenavigation-1f54f9916f71e516dfb53867600af368.png";